import React, { useEffect } from "react";
import MobileStores from "../homePage/MobileStores";
import HomeSearchBox from "../homePage/HomeSearchBox";
import HomeInform from "../homePage/HomeInform";
import { useSearchParams } from "next/navigation";
import HomeProvider from "@/context/homeContext";
import dynamic from "next/dynamic";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import FrequentlyAskedQuestions from "../homePage/FrequentlyAskedQuestions";
import HomeBlog from "../homePage/HomeBlog";
import HomeInformation from "../homePage/HomeInformation";

const HomeFeaturedVillas = dynamic(() =>
  import("../homePage/HomeFeatured/HomeFeaturedVillas")
);
const HomeCategory = dynamic(() => import("../homePage/HomeCategory"));
const HomeFindingWizard = dynamic(() =>
  import("../homePage/HomeFindingWizard")
);
const HomeLastMinute = dynamic(() => import("../homePage/HomeLastMinute"));
const HomeRegions = dynamic(() => import("../homePage/HomeRegions"));
const HomeShortTerm = dynamic(() => import("../homePage/HomeShortTerm"));
const HomeComments = dynamic(() => import("../homePage/HomeComments"));

const HomePage = ({ data }) => {
  const searchParams = useSearchParams();
  const {
    ProductDestinations,
    HomeContent,
    ProductCategories,
    faq,
    blog,
    icerik,
    static: { Reviews, GetOffer: offer, Banner1, Banner2 },
    slider,
  } = data;
console.log(HomeContent);

  useEffect(() => {
    const code = searchParams.get("pCode");
    if (code) {
      localStorage.setItem("PromotionCode", code);
    }
  }, [searchParams.get("pCode")]);

  const [sectionRef, isVisible] = useIntersectionObserver();
  return (
    <>
      <MobileStores storeCategories={ProductCategories} />
      <HomeProvider>
        <HomeSearchBox data={data} sliderCaption={slider} />
      </HomeProvider>
      <HomeInform Banner1={Banner1} Banner2={Banner2} />
      {HomeContent?.map((content) => (
        <HomeFeaturedVillas
          key={content.id}
          title={content.baslik}
          url={content.url}
          vitrins={content.vitrins}
        />
      ))}
      <div ref={sectionRef} />
      {isVisible && (
        <>
          <HomeCategory ProductCategories={ProductCategories} />
          <HomeFindingWizard offer={offer} />
          <HomeLastMinute />
          <HomeRegions regions={ProductDestinations} />
          <HomeShortTerm />
          <HomeComments Reviews={Reviews} />
        </>

      )}
      <FrequentlyAskedQuestions faq={faq} />
      <HomeBlog data={blog} />
      <HomeInformation content={icerik} />
    </>
  );
};

export default HomePage;
